// Light user argent parser
// Should cover at least 99.99% of instant game users
module.exports = function parseUserAgent (userAgent, referrer) {
  var parsingFailed = false;

  function getVersion (product) {
    var productPattern = new RegExp(product + '[^\\d._;]+[\\d._]+');
    var match = userAgent.match(productPattern);
    return match ? match[0].substring(product.length + 1).replace(/_/g, '.') : 'x.x.x';
  }

  var application;
  var applicationVersion;
  var os;
  var osVersion;
  var browser;
  var browserVersion;
  var isIOS = false;
  var isAndroid = false;
  var isWindowsPhone = false;

  try {
    var osPerDevice = {
      Linux: 'Android',
      iPhone: 'iPhone OS',
      iPad: 'iPhone OS',
      iPod: 'iPhone OS',
      Windows: 'Windows',
      Macintosh: 'Mac OS X',
      Android: 'Android',
      X11: 'Linux',
      'SMART-TV': 'Linux',
      compatible: 'Windows',
      connectpro: 'Windows',
      osmeta: 'iPhone OS'
    };

    var products = userAgent.split(/; | \(|\) /);

    // Determining OS
    var device;
    var productIdx = 0;
    do {
      if (productIdx >= products.length) {
        break;
      }

      var deviceDetailsPart = products[productIdx++];
      var end = deviceDetailsPart.indexOf(' ');
      device = (end === -1) ? deviceDetailsPart : deviceDetailsPart.substring(0, end);
      os = osPerDevice[device];
    } while (!os);

    if (!os) {
      os = 'UNKNOWN';
      osVersion = 'x.x.x';
    } else {
      var osSubstitutes = {
        iPad: 'OS',
        osmeta: 'osmeta'
      };

      var osString = osSubstitutes[device] || os;
      osVersion = getVersion(osString);
    }

    // Determinig browser
    // In decreasing order of choice
    var browsers = ['Trident', 'Edge', 'Firefox', 'Chrome', 'Safari', 'AppleWebKit'];

    var browserString;
    var browserIdx = 0;
    do {
      if (browserIdx >= browsers.length) {
        break;
      }

      browser = browsers[browserIdx++];
      var browserPattern = new RegExp(browser + '/[\\d.]+');
      var browserMatch = userAgent.match(browserPattern);
      if (browserMatch) {
        browserString = browserMatch[0];
      }
    } while (!browserString);

    if (!browserString) {
      browser = 'UNKNOWN';
      browserVersion = 'x.x.x';
    } else {
      browserVersion = browserString.substring(browserString.indexOf('/') + 1);
    }

    if (browser === 'Trident') {
      browser = 'Internet Explorer';
      var major = browserVersion.substring(0, browserVersion.indexOf('.'));
      browserVersion = Math.min(11, (parseInt(major) + 4)) + '.0';
    }

    isIOS = os === 'iPhone OS';
    isAndroid = os === 'Android';

    var isMobile = isIOS || isAndroid;
    if (userAgent.match('FBAN')) {
      var fbAppNamePattern = new RegExp('FBAN/[^ ;]+');
      var matchFBAppName = userAgent.match(fbAppNamePattern);
      application = matchFBAppName ? matchFBAppName[0].substring(5) : 'UNKNOWN';
      applicationVersion = getVersion('FBAV');
      if (application === 'MessengerForiOS') {
        application = 'MESSENGER';
      } else {
        if (osVersion === 'x.x.x') {
          osVersion = getVersion('FBSV');
        }
        if (application === 'FBIOS') {
          os = 'iPhone OS';
          isIOS = true;
        } else if (application === 'FB4A') {
          os = 'Android';
          isAndroid = true;
        } else if (application === 'FBWinPhone') {
          os = 'Windows';
          osVersion = getVersion('FBSV');
          isIOS = false;
          isAndroid = false;
          isWindowsPhone = true;
        }

        if (application.match(/^FB/)) {
          application = 'FACEBOOK';
        }
      }
    } else if (isMobile && userAgent.match(' Line/')) {
      application = 'LINE';
      applicationVersion = getVersion('Line');
    } else if (referrer.indexOf('www.messenger.com') !== -1) {
      application = 'MESSENGER';
      applicationVersion = 'x.x.x';
    } else if (referrer.indexOf('.facebook.com') !== -1) {
      application = 'FACEBOOK';
      applicationVersion = 'x.x.x';
    } else {
      application = 'UNKNOWN';
      applicationVersion = 'x.x.x';
    }
  } catch (e) {
    parsingFailed = true;

    os = 'UNKNOWN';
    osVersion = 'x.x.x';

    browser = 'UNKNOWN';
    browserVersion = 'x.x.x';

    application = 'UNKNOWN';
    applicationVersion = 'x.x.x';

    isIOS = false;
    isAndroid = false;
    isWindowsPhone = false;
  }

  return {
    string: userAgent,
    referrer: referrer,
    parsingFailed: parsingFailed,
    isMobile: (isIOS || isAndroid || isWindowsPhone),
    os: {
      name: os,
      version: osVersion,
      major: osVersion.split('.')[0],
      isIOS: isIOS,
      isAndroid: isAndroid,
      isWindowsPhone: isWindowsPhone
    },
    browser: {
      name: browser,
      version: browserVersion,
      major: browserVersion.split('.')[0]
    },
    app: {
      name: application,
      version: applicationVersion,
      major: applicationVersion.split('.')[0]
    }
  };
};
